module.exports = __webpack_public_path__ + "img/upload_bg@2x.bb8fdb53.png";